import { Injectable } from '@angular/core';
import { AbstractDialogService } from '@examdojo/core/dialog';
import { MarkCalculationMethod } from '@examdojo/models/markscheme-v2';
import { ReferenceQuestionUIModel } from '../reference-question.model';
import { ReferenceQuestionPopupComponent } from './reference-question-popup.component';

@Injectable()
export class ReferenceQuestionPopupService extends AbstractDialogService<ReferenceQuestionPopupInput, void> {
  readonly id = 'reference-question-popup';
  protected readonly component = ReferenceQuestionPopupComponent;

  override readonly options = {
    cssClass: 'modified-modal fullscreen action-sheet-on-mobile',
  };

  protected override readonly dismissOnBreakpointChange = true;

  override openDialog({ input }: { input: ReferenceQuestionPopupInput }) {
    return super.openDialog({
      options: {
        ...this.options,
        componentProps: {
          referenceQuestion: input.referenceQuestion,
          markCalculationMethod: input.markCalculationMethod,
        },
      },
    });
  }
}

interface ReferenceQuestionPopupInput {
  referenceQuestion: ReferenceQuestionUIModel;
  markCalculationMethod: MarkCalculationMethod;
}
